interface DiscountRowProps {
  label: string;
  price: string | JSX.Element;
  className?: string;
}

export function DiscountRow({
  label,
  price,
  className,
  ...props
}: DiscountRowProps) {
  return (
    <div
      className={`flex justify-between items-center ${className}`}
      {...props}
    >
      <span className="text-body">{label}</span>
      <span className="text-body-semibold" data-cy="price">
        {price}
      </span>
    </div>
  );
}
